import { objToQs } from "../Utils";

import Call from '../Call.v3';

import qs from 'querystring';

const Domains = {
    get(filters) {
        return Call(`domains?${qs.stringify(filters)}`);
    },
    update(entity) {
        return Call(`domains`,'PUT', entity);
    },
    save(entity) {
        return Call('domains','POST', entity);
    },
    remove(id) {
        return Call(`domains/${id}`,'DELETE');
    },
    types() {
        return Call(`domains/types`);
    },
    history(domain_id) {
        return Call(`domains/history?${objToQs({ domain_id })}`);
    },
};

export default Domains;



// WEBPACK FOOTER //
// ./src/services/API/components/DomainsV2.js